import { isAxiosError } from 'axios';

// backend の deps.get_current_user が返すエラーキー（detail.key）
export const TWO_FACTOR_ENROLLMENT_REQUIRED_KEY =
  '403_two_factor_enrollment_required';

type ErrorBody = {
  key?: string;
  detail?: string | { key?: string };
};

// テナントで2FAが必須化されているのに、ユーザーが2FA未設定のときの 403 かどうか
export const isTwoFactorEnrollmentRequiredError = (error: unknown): boolean => {
  if (!isAxiosError(error) || error.response?.status !== 403) {
    return false;
  }
  const body = error.response.data as ErrorBody | undefined;
  const key = typeof body?.detail === 'object' ? body.detail?.key : body?.key;
  return key === TWO_FACTOR_ENROLLMENT_REQUIRED_KEY;
};

// 403 を受けたときにログアウトするかどうか。
// 2FA未設定による 403 は、ログアウトしても未設定のままログインし直すだけなので
// ログアウトせず、2FAの設定画面へ誘導する（actionCheckApiError で処理する）。
export const shouldLogOutOnForbidden = (error: unknown): boolean =>
  isAxiosError(error) &&
  error.response?.status === 403 &&
  !isTwoFactorEnrollmentRequiredError(error);
